
import React from 'react';
import { useTranslation } from 'react-i18next';

function Buy() {
    const { t } = useTranslation();
    return (
        <section className="">
            <div className="tf-container">
                <div className="row justify-content-center">

          {/* Contenu long - Full width */}
          <div className="col-md-12 mt-1 ">
            <div
              className="content-box"
              style={{
                padding: "20px",
                borderRadius: "10px",
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
              }}
            >
              {/* <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Safe & Secure Transactions')}
                            </h3> */}
              <p className="content-text text-center" style={{ fontSize: "16px" }}>
                {t(
                  "When you decide to purchase FC 25 coins, one of the most important factors to consider is the safety of the transaction. We guarantee 100% secure transactions with advanced encryption methods, ensuring that your personal and financial information is always protected. Our platform adheres to the highest standards of security, offering you peace of mind throughout the entire buying process. There is no need to worry about account bans or security risks, as we operate within FIFA’s guidelines, making sure your experience is both safe and smooth."
                )}
              </p>
              <p className="content-text text-center" style={{ fontSize: "16px" }}>
                {t(
                  "In addition, we employ an efficient and secure payment system that includes multiple payment options, so you can choose the one that suits you best. Whether you prefer using credit/debit cards, PayPal, or cryptocurrencies, our system supports a wide range of methods, all backed by encryption protocols. Rest assured that every step of the transaction, from payment to delivery, is handled with utmost care."
                )}
              </p>
              <div
                className="col-md-12 text-center"
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div
                  className="content-box w-100"
                  style={{
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src="images/pages/fc3.avif"
                    alt="Safe & Secure Transactions"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      maxHeight: "500px",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              </div>

              <h3
                className="content-title"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                {t("Fast Delivery")}
              </h3>
              {/* <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Time is crucial when it comes to acquiring FC 25 coins. You don't want to wait around for days to get the coins you need for your next match. That’s why we’ve built an automated system that ensures your coins are delivered instantly. As soon as your payment is confirmed, the coins are sent to your account without delay. This fast delivery allows you to stay focused on improving your team and enjoying the game, rather than wasting time waiting for your purchase.")}
                            </p> */}
              <p className="content-text" style={{ fontSize: "16px" }}>
                {t(
                  "Our automated delivery system operates 24/7, so you can make a purchase at any time of the day or night and receive your coins instantly. Whether you're looking to enhance your squad for an upcoming tournament or just want to boost your team for daily gameplay, our fast delivery ensures you're never left behind. Experience the convenience and speed of our service and elevate your gaming experience without unnecessary delays."
                )}
              </p>

              <h3
                className="content-title"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                {t("Best Prices Guaranteed")}
              </h3>
              <p className="content-text" style={{ fontSize: "16px" }}>
                {t(
                  "We understand the importance of value when it comes to purchasing in-game items. That's why we offer the most competitive prices on the market for FC 25 coins. Our prices are regularly updated to ensure you get the best deal available, and we guarantee that you won't find a better price elsewhere. Whether you're purchasing a small or large amount of coins, we ensure that our prices remain affordable without compromising quality or service."
                )}
              </p>
              {/* <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Additionally, we offer special discounts and promotions throughout the year, so you can save even more. Keep an eye on our site for seasonal sales and limited-time offers that give you more value for your money. When you buy FC 25 coins from us, you’re getting the best deal on the market, ensuring that every purchase is worthwhile.")}
                            </p> */}

              <h3
                className="content-title"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                {t("24/7 Customer Support")}
              </h3>
              <p className="content-text" style={{ fontSize: "16px" }}>
                {t(
                  "We know that purchasing in-game currency can sometimes be confusing or even frustrating. That's why our dedicated customer support team is here to help you at any time. Whether you have a question about the buying process, need assistance with a payment method, or encounter any issues with your delivery, our team is always available to assist you."
                )}
              </p>
              <p className="content-text" style={{ fontSize: "16px" }}>
                {t(
                  "Our support team is available 24/7 through multiple channels, including live chat, email, and phone. You can reach out to us anytime, and we guarantee a fast response to resolve any issues. We pride ourselves on delivering excellent customer service, ensuring that your experience is smooth and hassle-free. With our support team on standby, you can buy your FC 25 coins with confidence, knowing that help is always just a click away."
                )}
              </p>

                    {/* Image - Centrée et en 8 colonnes */}
                    <div className="col-md-12 text-center" data-aos="fade-up" data-aos-duration="800">
                    <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("safe_secure_transactions_text")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("safe_secure_transactions_text2")}
                            </p>
                    </div>

                    {/* Contenu long - Full width */}
                    <div className="col-md-12 mt-4">
                        <div className="content-box" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                        <div className="content-box w-100" style={{ padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)" }}>
                            <img
                                src="images/pages/fc3.avif"
                                alt="Safe & Secure Transactions"
                                className="img-fluid"
                                style={{ width: "100%", maxHeight: "500px", borderRadius: "8px" }}
                            />
                        </div>
                            {/* <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('Safe_Secure_Transactions')}
                            </h3> */}
                          

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('fast_delivery')}
                            </h3>
                            {/* <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Time is crucial when it comes to acquiring FC 25 coins. You don't want to wait around for days to get the coins you need for your next match. That’s why we’ve built an automated system that ensures your coins are delivered instantly. As soon as your payment is confirmed, the coins are sent to your account without delay. This fast delivery allows you to stay focused on improving your team and enjoying the game, rather than wasting time waiting for your purchase.")}
                            </p> */}
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("fast_delivery_text")}
                            </p>

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('best_prices_guaranteed')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("best_prices_guaranteed_text")}
                            </p>
                            {/* <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("Additionally, we offer special discounts and promotions throughout the year, so you can save even more. Keep an eye on our site for seasonal sales and limited-time offers that give you more value for your money. When you buy FC 25 coins from us, you’re getting the best deal on the market, ensuring that every purchase is worthwhile.")}
                            </p> */}

                            <h3 className="content-title" style={{ fontSize: "20px", fontWeight: "600" }}>
                                {t('24_7_customer_support')}
                            </h3>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("24_7_customer_support_text")}
                            </p>
                            <p className="content-text" style={{ fontSize: "16px" }}>
                                {t("24_7_customer_support_text2")}
                            </p>
                        </div>
                    </div>

                </div>

            </div>
          </div>
        </div>
     
    </section>
  );
}

export default Buy;
